import { createSlice } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { planService } from "../services/lessonService";
import { createCustomAsyncThunk, defaultEntityAdapter } from "./utils";
import React from "react";
import toastWrapper from "../components/toastWrapper";

export const getPlans = createCustomAsyncThunk(
    "plans/get",
    async params => await planService.get(params)
)

export const createPlan = createCustomAsyncThunk(
    "plans/create",
    async data => await planService.post(data)
)

export const updatePlan = createCustomAsyncThunk(
    "plans/update",
    async data => await planService.patch(data)
)

export const deletePlan = createCustomAsyncThunk(
    "plans/delete",
    async data => await planService.delete(data)
)

const planSlice = createSlice({
    name: "plans",
    initialState: defaultEntityAdapter.getInitialState({
        isLoading: false,
        error: null,
        total: 0,
    }),
    extraReducers: builder => {
        builder
            .addCase(getPlans.pending, state => { state.isLoading = true })
            .addCase(getPlans.fulfilled, (state, action) => {
                defaultEntityAdapter.setAll(state, action.payload.results)
                state.total = action.payload.count
                state.isLoading = false
            })
            .addCase(getPlans.rejected, (state, action) => {
                state.error = action.error
                state.isLoading = false
            })

            .addCase(createPlan.pending, state => { state.isLoading = true })
            .addCase(createPlan.fulfilled, (state, action) => {
                defaultEntityAdapter.addOne(state, action.payload)
                state.isLoading = false
            })
            .addCase(createPlan.rejected, (state, action) => {
                state.error = action.error
                state.isLoading = false
            })

            .addCase(updatePlan.pending, state => { state.isLoading = true })
            .addCase(updatePlan.fulfilled, (state, action) => {
                defaultEntityAdapter.upsertOne(state, action.payload)
                state.isLoading = false
            })
            .addCase(updatePlan.rejected, (state, action) => {
                state.error = action.error
                state.isLoading = false
            })

            .addCase(deletePlan.pending, state => { state.isLoading = true })
            .addCase(deletePlan.fulfilled, (state, action) => {
                defaultEntityAdapter.removeOne(state, action.payload.id)
                state.isLoading = false
            })
            .addCase(deletePlan.rejected, (state, action) => {
                state.error = action.error
                state.isLoading = false
            })

    }
})

export const planSelectors = defaultEntityAdapter.getSelectors(x => x.plans)

export default planSlice.reducer

export const usePlans = (page, pageSize) => {

    const plans = useSelector(planSelectors.selectAll)
    const { isLoading, total } = useSelector(x => x.plans)

    const dispatch = useDispatch()

    React.useEffect(() => {
        dispatch(getPlans({ page: page + 1, page_size: pageSize }))
    }, [page, pageSize, dispatch])

    const handleCreatePlan = data => dispatch(createPlan(data)).unwrap().then(
        () => { toastWrapper("План создан", "success") },
        () => { toastWrapper("Ошибка при создании плана") }
    )
    const handleUpdatePlan = data => dispatch(updatePlan(data)).unwrap().then(
        () => { toastWrapper("План обновлен", "success") },
        () => { toastWrapper("Ошибка при обновлении плана") }
    )
    const handleDeletePlan = data => dispatch(deletePlan(data)).unwrap().then(
        () => { toastWrapper("План удален", "success") },
        () => { toastWrapper("Ошибка при удалении плана") }
    )

    return { plans, isLoading, page, total, handleCreatePlan, handleUpdatePlan, handleDeletePlan }
}
